
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  getAlarmSettingPage,
  getBatchSetting,
  alarmSaveSingle
  // alarmSingleDel
} from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class AlarmSettingOrder extends Vue {
  @Prop({
    default: () => {
      return {};
    },
    type: Object
  })
  private privilege!: objAny;
  @Prop({ default: "" }) private tabName!: string;
  private total = 0;
  private loading = false;
  private formInline: objAny = {
    pageIndex: 1,
    pageSize: 10,
    globalOrder: ""
  };
  private ruleInline = {};
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      title: i18n.t("alarmsetting.faultCode"),
      key: "faultCode",
      sortable: true,
      minWidth: 120
    },
    {
      title: i18n.t("alarmsetting.alarmLevel"),
      key: "alarmLevel",
      minWidth: 180,
      slot: "levelSelect"
    },
    {
      title: i18n.t("alarmsetting.faultName"),
      key: "faultName",
      minWidth: 180
    },
    {
      title: i18n.t("operation"),
      key: "userName",
      resizable: true,
      minWidth: 140,
      slot: "action"
    }
  ];
  private batchSettingList: object[] = [];

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  public timeChange(data: objAny): void {
    this.formInline.startTime = data.startTime;
    this.formInline.endTime = data.endTime;
  }

  public queryClick(): void {
    this.formInline.pageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.pageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.pageSize = val;
    this.getTableList();
  }

  public saveSingleBtn(item: objAny): void {
    // this.alarmQueryDetail.open(item, index);

    const param = {
      rulePkId: item.rulePkId,
      alarmLevel: item.alarmLevel,
      faultCode: item.faultCode
    };
    this.subSaveSingle(param);
  }

  // public delSingleItem(item: objAny): void {
  //   this.$Modal.confirm({
  //     title: "提示",
  //     content: "确定删除吗？",
  //     onOk: () => {
  //       this.SingleDelitem(item.rulePkId);
  //     }
  //   });
  // }

  public handelChange(item: objAny, index: number): void {
    console.log(item, index);
    // console.log(this.tableList[index]);
  }

  // async SingleDelitem(val: objAny): Promise<void> {
  //   const ret = await alarmSingleDel({ rulePkId: val });
  //   if (ret.status === this.$config.apiStatus) {
  //     this.$Message.success("删除成功");
  //     this.getTableList();
  //   }
  // }

  async subSaveSingle(val: objAny): Promise<void> {
    const ret = await alarmSaveSingle(val);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.getTableList();
    }
  }

  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getAlarmSettingPage(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      const list = ret.data;
      for (let i = 0; i < list.length; i++) {
        list[i].index = i + 1;
      }
      this.tableList = list;
      // this.tableList = [
      //   {
      //     alarmLevel: 1,
      //     faultCode: 10,
      //     faultName: "哆来咪",
      //     rulePkId: 1
      //   },
      //   {
      //     alarmLevel: 1,
      //     faultCode: 10,
      //     faultName: "哆来咪",
      //     rulePkId: 1
      //   },
      //   {
      //     alarmLevel: 1,
      //     faultCode: 10,
      //     faultName: "哆来咪",
      //     rulePkId: 1
      //   },
      //   {
      //     alarmLevel: 1,
      //     faultCode: 10,
      //     faultName: "哆来咪",
      //     rulePkId: 1
      //   }
      // ];
    }
    this.loading = false;
  }

  async getBatchSettingList(): Promise<void> {
    const ret = await getBatchSetting();
    if (ret.status === this.$config.apiStatus) {
      this.batchSettingList = ret.data;
    }
  }

  mounted() {
    this.getBatchSettingList();
    this.getTableList();
  }
}
